import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MaxBrainSharedModule } from 'app/projects/shared/src/lib/shared.module';
import { RequestDateFilterComponent } from './request-date-filter.component';

@NgModule({
    imports: [MaxBrainSharedModule, MatDatepickerModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule],
    declarations: [RequestDateFilterComponent],
    exports: [RequestDateFilterComponent],
})
export class RequestDateFilterModule {}
